import React from 'react';
import { Field } from 'react-final-form';
import Input from '@teetsh/app/src/components/Form/InputGroup/formWrapper';
import Card from '@teetsh/app/src/components/Card';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';
import { Infobox } from 'components/Callout/Infobox';

const cardStyle = tw`mb-3 relative px-3 pt-3 pb-4`;

export default function LibellesSettings() {
  const { t } = useTranslation(['userSettings']);
  return (
    <>
      <Infobox tw="mb-3" intent="primary">
        {t('userSettings:curriculumLabels.description')}
      </Infobox>
      {[
        {
          value: 'matiere',
          label: t('userSettings:curriculumLabels.matiere'),
        },
        {
          value: 'domaine',
          label: t('userSettings:curriculumLabels.domaine'),
        },
        {
          value: 'competence',
          label: t('userSettings:curriculumLabels.competence'),
        },
        {
          value: 'objectif',
          label: t('userSettings:curriculumLabels.goal'),
        },
      ].map(item => (
        <Card color="gray-300" css={cardStyle} key={item.value}>
          <div tw="mb-2 text-lg font-medium">{item.label}</div>
          <div tw="grid grid-cols-2 gap-2">
            <div tw="col-span-full md:col-span-1">
              <Field
                name={`boLabels.${item.value}SingularName`}
                withoutMargin
                label={t('userSettings:curriculumLabels.nameSingular')}
                component={Input}
              />
            </div>
            <div tw="col-span-full md:col-span-1">
              <Field
                name={`boLabels.${item.value}PluralName`}
                withoutMargin
                label={t('userSettings:curriculumLabels.namePlural')}
                component={Input}
              />
            </div>
          </div>
        </Card>
      ))}
      <Card color="gray-300" css={cardStyle}>
        <div tw="mb-2 text-lg font-medium">
          {t('userSettings:curriculumLabels.activite')}
        </div>
        <div tw="w-full md:w-1/2">
          <Field
            name="boLabels.activitiesName"
            props={{ label: t('userSettings:curriculumLabels.name') }}
            withoutMargin
            component={Input}
          />
        </div>
      </Card>
    </>
  );
}
